// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"xU pZ","whiteTheme":"xV","markdownWrapper":"xW"};